import * as React from 'react';
import type { FieldProps } from '@rjsf/utils';
import CodeEditorWidget from '../widgets/CodeEditor';

/**
 * Custom RJSF field that renders a JSON/code editor for object/array (or any) values.
 * It wraps the existing CodeEditorWidget so we get JSON <-> value coercion when schema.type is object/array/etc.
 */
export default function JsonField(props: FieldProps) {
  const {
    idSchema,
    schema,
    uiSchema,
    formData,
    onChange,
    disabled,
    readonly,
  } = props as FieldProps;

  const id = idSchema && (idSchema as any).$id ? (idSchema as any).$id : undefined;
  const uiOptions = (uiSchema && (uiSchema as any)['ui:options']) || {};
  const placeholder = (uiSchema && (uiSchema as any)['ui:placeholder']) || undefined;
  const language = (uiOptions as any).language || 'json';

  return (
    <CodeEditorWidget
      id={id as any}
      schema={schema as any}
      value={formData as any}
      onChange={onChange as any}
      disabled={disabled}
      readonly={readonly}
      options={{ ...(uiOptions as any), language }}
      placeholder={placeholder}
    />
  );
}

